export default {"src":"/_next/static/media/folders-logo.4d22082e.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};